import React, { useEffect, useState } from "react";
import NextStepCard from "./NextStepCard";
import DashboardIcon from "@mui/icons-material/Dashboard";

import { useLocation } from "react-router-dom";

/**
 * DemoCompletionGuidance
 * Monitors session storage for visited flags of all 4 modules.
 * Displays a completion message when all are visited.
 */
export default function DemoCompletionGuidance() {
    const [showCompletion, setShowCompletion] = useState(false);
    const isLiveDemo = sessionStorage.getItem('demo_role_cache') === "demo_viewer";
    const location = useLocation(); // Hook to detect route changes

    useEffect(() => {
        if (!isLiveDemo) return;

        // --- 1. Semi-Autonomous Visit Tracking ---
        const path = location.pathname;

        // Insight Hub is the only page we track automatically on landing
        if (path.includes("insight-hub")) {
            sessionStorage.setItem("demo_visited_hub", "true");
        }

        // --- 2. Completion Check Function ---
        const checkCompletion = () => {
            const visitedStash = sessionStorage.getItem("demo_visited_stash");
            const visitedStudio = sessionStorage.getItem("demo_visited_studio");
            const visitedHub = sessionStorage.getItem("demo_visited_hub");
            const visitedScout = sessionStorage.getItem("demo_visited_scout");
            const alreadyShown = sessionStorage.getItem("demo_completion_shown");

            if (visitedStash && visitedStudio && visitedHub && visitedScout && !alreadyShown) {
                setShowCompletion(true);
                sessionStorage.setItem("demo_completion_shown", "true");
            }
        };

        // Run check with a small delay to allow manual flags to settle
        const timer = setTimeout(checkCompletion, 1000);

        // Listen for manual triggers from page actions (Analyse, Search, Create Snapshot)
        const handleEvent = checkCompletion;
        window.addEventListener('demoVisitUpdated', handleEvent);

        return () => {
            clearTimeout(timer);
            window.removeEventListener('demoVisitUpdated', handleEvent);
        };
    }, [isLiveDemo, location.pathname]);

    if (!showCompletion) return null;

    return (
        <NextStepCard
            visible={showCompletion}
            title="Guided Tour Complete!"
            body="You have successfully explored all the features of comparedly.<br/>Navigate around Comparedly using the Side nav bar."
            buttonText="Go to Dashboard"
            buttonLink="/dashboard"
            icon={<DashboardIcon />}
            onDismiss={() => setShowCompletion(false)}
        />
    );
}
